export const dashboardStats = /* GraphQL */ `
  query dashboardStats {
    dashboardStats {
      likieesTotal
      mostPriceDropped {
        brand
        availability
        currency
        features
        description
        id
        imageURL
        images
        price
        originalPrice
        priceTrend
        priceRange {
          min
          max
          currency
          count
        }
        name
        thumbnailURLs
        url
        regularPrice
        probability
        status
        projects {
          items {
            id
          }
        }
        source {
          name
          id
          faviconURL
          url
        }
        item {
          mainImage
        }
        size
        locale
        categoryTags
      }
      recentLikiees {
        brand
        availability
        currency
        features
        description
        id
        imageURL
        images
        price
        originalPrice
        priceTrend
        priceRange {
          min
          max
          currency
          count
        }
        name
        thumbnailURLs
        url
        regularPrice
        probability
        status
        projects {
          items {
            id
          }
        }
        source {
          name
          id
          faviconURL
          url
        }
        item {
          mainImage
        }
        size
        locale
        categoryTags
      }
      sharedProjectsWithYou {
        icon
        id
        itemsCount
        name
        visibility
        visibilityGroup
        owner
        user {
          picture
          id
          name
          email
        }
      }
      followersProjects {
        icon
        id
        itemsCount
        name
        visibility
        visibilityGroup
        owner
        user {
          picture
          id
          name
          email
        }
      }
    }
  }
`;
